/* eslint-disable */
/* eslint-disable no-void */
/* eslint-disable no-nested-ternary */
/* eslint-disable one-var */
/* eslint-disable no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable wrap-iife */
/* eslint-disable no-cond-assign */
/* eslint-disable quotes */
/* eslint-disable no-undef */
// eslint-disable-next-line func-names
const ctaLink = document.getElementById('create-site');

window.onresize = function () {
  const windowSize = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  if (windowSize <= 767) {
    ctaLink.href = 'https://www.icasei.com.br/planos?oid=revista&utm_campaign=aon&utm_term=cta_footer_mobile';
  } else {
    ctaLink.href = 'https://www.icasei.com.br/planos?oid=revista&utm_campaign=aon&utm_term=cta_post';
  }
};
